import { render, staticRenderFns } from "./releaseUpdate.vue?vue&type=template&id=1f0969ae&"
import script from "./releaseUpdate.vue?vue&type=script&lang=js&"
export * from "./releaseUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports